import { render, staticRenderFns } from "./comprehensiveAnalysis.vue?vue&type=template&id=a81679ac"
import script from "./comprehensiveAnalysis.vue?vue&type=script&lang=js"
export * from "./comprehensiveAnalysis.vue?vue&type=script&lang=js"
import style0 from "./comprehensiveAnalysis.vue?vue&type=style&index=0&id=a81679ac&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports